import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

/** Mount point for the Insights page (e.g. `/insights`). */
export const rootRouteRef = createRouteRef({
  id: 'custom-metrics',
});

/** `/insights/usage` */
export const insightsUsageRouteRef = createSubRouteRef({
  id: 'custom-metrics.usage',
  parent: rootRouteRef,
  path: '/usage',
});

/** `/insights/usage/users` */
export const insightsUsageUsersRouteRef = createSubRouteRef({
  id: 'custom-metrics.usage.users',
  parent: rootRouteRef,
  path: '/usage/users',
});

/** `/insights/usage/catalog` */
export const insightsUsageCatalogRouteRef = createSubRouteRef({
  id: 'custom-metrics.usage.catalog',
  parent: rootRouteRef,
  path: '/usage/catalog',
});

/** `/insights/usage/templates` */
export const insightsUsageTemplatesRouteRef = createSubRouteRef({
  id: 'custom-metrics.usage.templates',
  parent: rootRouteRef,
  path: '/usage/templates',
});

/** `/insights/usage/search` */
export const insightsUsageSearchRouteRef = createSubRouteRef({
  id: 'custom-metrics.usage.search',
  parent: rootRouteRef,
  path: '/usage/search',
});
